import { ReactNode } from "react";
import { Location, useBlocker } from "react-router-dom";

type NavigationBlockerWhenFn = (currentLocation: Location, nextLocation?: Location) => boolean;

type NavigationBlockerProps = {
  when: boolean | NavigationBlockerWhenFn;
  children: (props: { onConfirm: () => void; onCancel: () => void }) => ReactNode;
};

/** Blocks in-app navigation when `when` is true, mirroring react-router-navigation-prompt. */
export function NavigationBlocker(props: NavigationBlockerProps) {
  const { when, children } = props;

  const shouldBlock =
    typeof when === "function"
      ? ({ currentLocation, nextLocation }: { currentLocation: Location; nextLocation: Location }) =>
          when(currentLocation, nextLocation)
      : when;

  const blocker = useBlocker(shouldBlock);

  if (blocker.state !== "blocked") {
    return null;
  }

  return <>{children({ onConfirm: () => blocker.proceed?.(), onCancel: () => blocker.reset?.() })}</>;
}
